import { render, staticRenderFns } from "./lightSwitch.vue?vue&type=template&id=6c817501"
import script from "./lightSwitch.vue?vue&type=script&lang=js"
export * from "./lightSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports